import { actionClient } from '@/api'

export default {

  namespaced: true,

  state: {
    apply: {},
  },


  mutations: {

    setApply(state, apply) {
      state.apply = apply
    },

  },

  actions: {
    async apply({ commit }, { orderId, isWechat = false, openid = '' }) {
      const data = await actionClient.post(`pay-apply/${orderId}`, { isWap: true, isWechat, openid })
      commit('setApply', data)
    }
  }


}
